module.exports = __webpack_public_path__ + "static/media/3-5.ffe356f9.mp3";